import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=1c2a3381&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=1c2a3381&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a3381",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2a3381')) {
      api.createRecord('1c2a3381', component.options)
    } else {
      api.reload('1c2a3381', component.options)
    }
    module.hot.accept("./TreeItem.vue?vue&type=template&id=1c2a3381&scoped=true", function () {
      api.rerender('1c2a3381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TreeItem.vue"
export default component.exports